/**
 * What a withholding rule holds back when `net` is what remains of the gross after `percent` of it.
 *
 * Display only: the server recomputes this on save and is authoritative. It mirrors the server's
 * formula (a share of the GROSS, so 900 paid under a 10% rule means 1,000 was owed and 100 is
 * withheld, not 90) so the screen can show the figures before the voucher is saved.
 */
export const withheldOnNet = (net: number, percent: number): number => {
  if (net <= 0 || percent <= 0 || percent >= 100) return 0;
  return Math.round((net * percent / (100 - percent)) * 100) / 100;
};
